import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  addToCompare,
  addToCompareFailure,
  addToCompareSuccess,
  getInstitutionsInCompare,
  getInstitutionsInCompareSuccess,
  sendEmail,
  sendEmailSuccess
} from './compare.actions';
import { CompareFacadeService } from './compare.facade';
import { catchError, filter, map, of, switchMap, take } from 'rxjs';
import { EmailService } from '../../services/email.service';
import { loadError } from '../error/error.action';
import { createActionError } from '../../models/action-error';
import { SnackbarService } from '../../services/snackbar.service';
import { CompareService } from './compare.service';

@Injectable()
export class CompareEffects {
  constructor(
    private actions$: Actions,
    private compareFacadeService: CompareFacadeService,
    private emailService: EmailService,
    private snackbarService: SnackbarService,
    private compareService: CompareService
  ) {}

  public addToCompare$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addToCompare),
      switchMap(({ institution }) => {
        return this.compareFacadeService.institutions$.pipe(
          take(1),
          map((institutions) => {
            if (
              institutions.length === 3 // max 3 item
            ) {
              return addToCompareFailure({ message: 'Can not add more than 3 items in Compare' });
            }

            if (
              institutions.some((item) => item?.id === institution.id) // exist
            ) {
              return addToCompareFailure({ message: 'The Institution already exists' });
            }
            this.snackbarService.success('Institution was added');
            return addToCompareSuccess({ institution });
          })
        );
      })
    )
  );

  public sendEmail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(sendEmail),
      switchMap(({ body }) => {
        return this.emailService.sendEmail(body).pipe(
          map((data) => {
            return sendEmailSuccess({ data });
          }),
          catchError((error) => {
            return of(loadError(createActionError(error.message ?? 'Send email Failure')));
          })
        );
      })
    )
  );

  public getInstitutionsInCompare$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getInstitutionsInCompare),
      switchMap(() => this.compareFacadeService.institutions$),
      switchMap((institutions) => {
        if (!!institutions.length) {
          return this.compareService.getInstitutionsInCompare(institutions).pipe(
            map((data) => {
              return getInstitutionsInCompareSuccess({ institutions: data });
            }),
            catchError((error) => {
              return of(
                loadError(createActionError(error.message ?? 'get Institutions In Compare Failure'))
              );
            })
          );
        }
        return of(getInstitutionsInCompareSuccess({ institutions: [] }));
      })
    )
  );
}
